import React, { useContext, useRef, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import ReactModal from 'react-modal-resizable-draggable';
import HtmlComponent from '../HtmlComponent';
import '../../../css/Tools.scss';
import '../../../css/Accessibility.scss';
import { register } from '../../../i18n';
import useAccessibilityClick from '../../../hooks/useAccessibilityClick';
import DialogPositionService from '../../services/DialogPositionService';
import accessibilityService from '../../services/AccessibilityService';

const t = register('ToolNames');
const t2 = register('AriaLabels');

const Instruction = observer(() => {
  const {
    toolbarManager
  } = useContext(MobXProviderContext);

  const closeRef = useRef();
  const contentRef = useRef();
  
  // Announce when Instruction dialog opens and focus on content
  useEffect(() => {
    accessibilityService.announceMessage('Student Instructions dialog opened');
    
    // Focus on the readable content area after a short delay to ensure the modal is rendered
    setTimeout(() => {
      if (contentRef.current) {
        contentRef.current.focus();
      }
    }, 100);
  }, []);

  useAccessibilityClick(closeRef, closeInstruction);

  function closeInstruction() {
    // Announce when Instruction dialog closes
    accessibilityService.announceMessage('Student Instructions dialog closed');
    
    toolbarManager.setIsInstructionOpen(false);
    toolbarManager.toggleToolOff(toolbarManager.instructionOpenId);
  }

  return (
    <div className='instructionTool'>
      <ReactModal
        initHeight={300}
        initWidth={800}
        isOpen={true}
        onRequestClose={closeInstruction}
        top={DialogPositionService.getDefaultTopPosition()}
        role="dialog"
        aria-labelledby="instruction-dialog-title"
        aria-describedby="instruction-dialog-content">
        <div className='modalBody'  tabIndex='0'>
          <div className='tool-header'>
            <h2 id="instruction-dialog-title" className='title-label basic' aria-label={t('instructionTitle', 'Student Instructions')}>{t('instructionTitle', 'Student Instructions')}</h2>
            <div ref={closeRef} aria-label={t2('closedialog')} className='x-close-button' role='button' tabIndex='0' />
          </div>
          <div 
            ref={contentRef}
            id="instruction-dialog-content" 
            className='article-container' 
            data-allow='1'
            tabIndex='0'
            role='document'
            aria-label='Student Instructions content'>
            <HtmlComponent htmlStr={toolbarManager.instructionData} />
          </div>
        </div>
      </ReactModal>
    </div>
  );
});

export default Instruction;
